<template>
  <v-snackbar
    v-model="snackbar"
    color="white"
    variant="elevated"
    :timeout="-1"
    :location="'right'"
    :style="`bottom: ${index * 65 + 25 * pastNotificationInfoLength}px;`"
    max-width="100%"
  >
    <div class="d-flex justify-space-around align-center">
      <v-icon color="success" class="pe-2">
        mdi-check-underline-circle-outline
      </v-icon>
      <span class="font-weight-medium" style="color: black">{{ text }}</span>
    </div>

    <template #actions>
      <v-btn color="success" variant="text" @click="closeToast"> Cerrar </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Success",
  props: {
    text: String,
    id: Number,
    index: Number,
    status: Number,
    pastNotificationInfoLength: Number,
  },
  emits: ["closeToast"],
  setup(props, { emit }) {
    const snackbar = ref(true);

    const closeToast = () => {
      snackbar.value = false;
      emit("closeToast", props.id);
    };

    return {
      snackbar,
      closeToast,
    };
  },
};
</script>

<style></style>
